
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/choose-account",
      function () {
        return require("private-next-pages/account/choose-account.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/choose-account"])
      });
    }
  